<template>
  <div class="alertPatent contentBack">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>续期预警 </el-breadcrumb-item>
      <el-breadcrumb-item class="breadSelected">专利预警 </el-breadcrumb-item>
    </el-breadcrumb>
    <div style="overflow-y: auto; height: 100%">
      <div class="listTitle titleBold gjcx">
        高级查询
        <span @click="handlegjcxShow">[展开/收起]</span>
      </div>
      <div class="gjcxContent" v-if="gjcxShow">
        <el-form
          ref="form"
          :model="form"
          label-width="82px"
          label-position="left"
        >
          <!-- 第一行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item class="elform30" label="申请人：" size="mini">
              <el-input
                v-model="form.ap"
                placeholder="输入申请人名称"
              ></el-input>
            </el-form-item>
            <el-form-item class="elform30" label="专利号：" size="mini">
              <el-input v-model="form.an" placeholder="输入专利号"></el-input>
            </el-form-item>
            <el-form-item class="elform30" label="公开号：" size="mini">
              <el-input v-model="form.pan" placeholder="输入公开号"></el-input>
            </el-form-item>
          </div>
          <!-- 第二行 -->
          <div style="display: flex; justify-content: space-between">
            <el-form-item class="elform30" label="专利名称：" size="mini">
              <el-input
                v-model="form.name"
                placeholder="输入专利名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="申请日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.sapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.eapd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="公开日：" size="mini" style="width: 30%">
              <el-row>
                <!-- span的值为24 -->
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.spd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
                <el-col :span="2"> 至 </el-col>
                <el-col :span="11">
                  <el-date-picker
                    type="date"
                    placeholder="年/月/日"
                    v-model="form.epd"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <!-- 第三行 -->
          <el-form-item label="授权日：" size="mini" style="width: 30%">
            <el-row>
              <!-- span的值为24 -->
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="年/月/日"
                  v-model="form.sad"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-col>
              <el-col :span="2"> 至 </el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="年/月/日"
                  v-model="form.ead"
                  style="width: 100%"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <!-- 第四行 -->
          <el-form-item label="行政区域：">
            <div style="display: flex">
              <el-checkbox
                v-model="checkAll5"
                @change="handleCheckAllChange5"
                style="margin-right: 30px"
                >全选</el-checkbox
              >
              <el-checkbox-group
                v-model="form.cnty"
                @change="handleCheckedCompanyChange5"
              >
                <el-checkbox
                  v-for="(region, index) of regions"
                  :key="index"
                  :label="region"
                ></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <!-- 按钮 -->
          <el-form-item label-width="0">
            <el-button
              style="background: #1890ff; padding: 10px 24px"
              type="primary"
              @click="onSubmit"
              >查 询</el-button
            >
            <el-button
              style="padding: 10px 24px; margin-left: 46px"
              @click="resetData"
              >重 置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- 选择未提醒和已提醒 -->
      <div class="alertType">
        <div :class="{ chooseAlert: alert == 0 }" @click="alertClick(0)">
          未提醒
        </div>
        <div :class="{ chooseAlert: alert == 1 }" @click="alertClick(1)">
          已提醒
        </div>
      </div>
      <!-- 查询结果列表 -->
      <div class="alertResult" v-show="alert == 0">
        <div class="listTitle">查询列表
           <div class="alrtbtn">
          <span style="color: #FF5C20; margin-right: 16px"
            >注：届满后{{ ptDayEnd }}天数据将自动取消提醒，请尽快处理！</span
          >
          <el-button
            :disabled="multipleSelection.length == 0"
            @click="manyAlert"
            >批量提醒</el-button
          >
          <el-button @click="daochu">导出Excel</el-button>
        </div>
        </div>
       
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column :resizable="false" type="selection" width="55"> </el-table-column>
          <el-table-column :resizable="false" type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column :resizable="false"
            label="申请人名称"
            prop="ap"
            min-width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :resizable="false"
            label="申请人地址"
            prop="apad"
            min-width="110"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column :resizable="false" label="预警专利量" prop="ptNum" width="100">
            <template slot-scope="scope">
              <div class="apStyle" @click="alertDetails(scope.row)">
                {{ scope.row.ptNum }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false"
            label="联系人"
            width="120"
            prop="frdb"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :resizable="false" label="联系人电话" prop="tel" width="150">
          </el-table-column>
          <el-table-column  label="操作" width="180">
            <template slot-scope="scope">
              <div class="changeAlert">
                <button @click="updataApplyermsg(scope.row)">修改</button>
                <!-- <el-popconfirm
                  width="272"
                  icon="el-icon-warning"
                  icon-color="#FAAD14"
                  v-model="sendmsg"
                  title="点击确认可向该申请人发送短信信息提醒"
                  @confirm="sendConfirm(scope.row)"
                  style="display: block; min-width: 77px"
                  placement="top-end"
                > -->
                  <!-- <button slot="reference">提醒</button> -->
                <!-- </el-popconfirm> -->
                <!-- <button>提醒</button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage4"
            :page-sizes="[10, 15, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
            <el-button size="mini" type="primary" style="margin-left: 5px"
          >确定</el-button
        >
        </div>
      </div>
      <!-- 已提醒 -->
      <div class="alertResult" v-show="alert == 1">
        <div class="listTitle">查询列表
          <div class="alrtbtn">
          <el-button @click="daochu2">导出Excel</el-button>
        </div> </div>
        
        <el-table
          ref="multipleTable1"
          :data="tableDataD"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange1"
          border
          @sort-change="sort2"
        >
          <el-table-column :resizable="false" type="selection" width="55"> </el-table-column>
          <el-table-column :resizable="false"
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="申请人名称"
            prop="ap"
            min-width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :resizable="false"
            label="申请人地址"
            prop="apad"
            min-width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :resizable="false" label="已预警专利" prop="ptNum"></el-table-column>
          <el-table-column :resizable="false"
            label="累计提醒次数"
            prop="logNum"
            min-width="85"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="近1年提醒次数"
            prop="thisYearLogNum"
            min-width="90"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="最近提醒日期"
            prop="createTime"
            sortable="custom"
            min-width="100"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="联系人"
            width="120"
            prop="frdb"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :resizable="false"
            label="联系人电话"
            prop="tel"
            width="150"
          ></el-table-column>
        </el-table>
         <div class="page-pagination">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-pag.sync="currentPage5"
            :page-sizes="[10, 15, 20]"
            :page-size="pageSize1"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          >
          </el-pagination>
            <el-button size="mini" type="primary" style="margin-left: 5px"
          >确定</el-button
        >
        </div>
      </div>
    </div>
    <!-- ------------------------弹框---------------------------------- -->
    <!-- 修改申请人信息 -->
    <div v-if="updataBox" class="popBoxMask"></div>
    <div v-if="updataBox" class="popBox">
      <div class="boxHeader">
        修改申请人信息
        <i class="el-icon-close" @click="closeTk1"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">详情信息</div>
        <div class="Reupdate boxForm">
          <div><span>申请人名称：</span>{{ updateBoxmsg.ap }}</div>
          <div><span>申请人地址：</span>{{ updateBoxmsg.address }}</div>
          <div style="display: flex">
            <div>
              <span>联系人：</span
              ><input type="text" v-model="updateBoxmsg.man" />
            </div>
            <div style="margin-left: 41px">
              <span>联系人电话：</span
              ><input type="text" v-model="updateBoxmsg.tel" />
            </div>
          </div>
        </div>
        <div class="reBtnb">
          <el-button @click="closeTk1">取消修改</el-button>
          <el-button @click="confirm">确认修改</el-button>
        </div>
      </div>
    </div>
    <!--  预警专利信息列表-->
    <div v-if="listBox" class="popBoxMask"></div>
    <div v-if="listBox" class="popBox listBox">
      <div class="boxHeader">
        {{ listName }}预警专利信息
        <i class="el-icon-close" @click="closeTk2"> </i>
      </div>
      <div class="boxContent">
        <div class="listTitle titleBold">预警专利信息列表</div>
        <el-table
          ref="multipleTable"
          :data="tableDatazl"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange2"
          border
          @sort-change="sort"
        >
          <el-table-column :resizable="false" type="selection" width="55"> </el-table-column>
          <el-table-column :resizable="false" type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column :resizable="false" label="申请号" prop="sPatentnumber" min-width="145">
            <template slot-scope="scope">
              <div style="color: #1773d5">{{ scope.row.sPatentnumber }}</div>
            </template>
          </el-table-column>
          <el-table-column :resizable="false"
            label="专利名称"
            prop="sTitle"
            show-overflow-tooltip
            min-width="150"
          >
          </el-table-column>
          <el-table-column :resizable="false"
            label="申请人"
            prop="sProposer1st"
            show-overflow-tooltip
            min-width="150"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="专利类型"
            prop="sPatenttype"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="申请日"
            prop="dtApplydate"
            sortable="custom"
            min-width="100"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="公开号"
            prop="sPubnumber"
            min-width="120"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="公开日"
            prop="dtPubdate"
            sortable="custom"
            min-width="100"
          ></el-table-column>
          <el-table-column :resizable="false"
            label="授权日"
            prop="dtAuthdate"
            sortable="custom"
            min-width="100"
          >
          </el-table-column>
          <el-table-column :resizable="false"
            label="IPC分类/LOC分类"
            prop="sMainipc"
            min-width="140"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
         <div class="page-pagination">
          <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage6"
            :page-sizes="[10, 15, 20]"
            :page-size="pageSize2"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total2"
          >
          </el-pagination>
            <el-button size="mini" type="primary" style="margin-left: 5px"
          >确定</el-button
        >
           
        </div>
      </div>
    </div>
    <!-- -------------------------------------------------------------- -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  inject: ["reload"],
  data() {
    return {
      gjcxShow: true,
      checkAll5: false,
      currentPage4: 1,
      currentPage5: 1,
      currentPage6: 1,
      regions: [],
      formcopy: {},
      form: {
        ap: "", //申请人名
        an: "", //专利申请号
        pan: "", //公开号
        name: "", // 专利名
        sapd: "", // 申请日1
        eapd: "", //申请日2
        spd: "", //公开日1
        epd: "", //公开日2
        sad: "", //授权日1
        ead: "", //授权日2
        cnty: [], //行政区域
      },
      alert: 0,
      tableData: [],
      tableDataD: [],
      tableDatazl: [],
      multipleSelection: [],
      multipleSelection1: [],
      total: 0,
      total1: 0,
      total2: 0,
      pageSize: 10,
      pageSize1: 10,
      pageSize2: 10,
      pageNum: 1,
      pageNum1: 1,
      pageNum2: 1,
      ptDayEnd: localStorage.getItem("ptDayEnd"),
      updataBox: false,
      updateBoxmsg: {
        apid: "",
        ap: "",
        address: "",
        man: "",
        tel: "",
      },
      sendmsg: "",
      listName: "",
      listBox: false,
      orderType: "",
      orderType1: "desc",
      order: "",
      order1: "",
      listapid: "",
      aps: "",
      tels: "",
      nums: "",
      mountAlert: true,
      mountAlert1: true,
      isSubmit: false,
    };
  },
  methods: {
    sort(col) {
      if (col.order == "descending") {
        this.orderType = "desc";
      } else if (col.order == "ascending") {
        this.orderType = "asc";
      }
      this.order = col.prop;
      this.alertDetailsmethod();
    },
    sort2(col) {
      if (!this.isSubmit) {
        if (col.order == "descending") {
          this.orderType1 = "desc";
        } else if (col.order == "ascending") {
          this.orderType1 = "asc";
        }
        this.order1 = col.prop;
        if (this.mountAlert1) {
          this.hasAlerted();
        } else {
          this.alertedptSearch();
        }
      }
    },
    closeTk2() {
      this.listBox = false;
    },
    alertDetailsmethod() {
      this.$GET("/alert/ptList", {
        apid: this.listapid,
        order: this.order,
        orderType: this.orderType,
        pageSize: this.pageSize2,
        pageNum: this.pageNum2,
      }).then((res) => {
        this.tableDatazl = res.data.records;
        this.tableDatazl.forEach((ele) => {
          if (ele.sPatenttype == "1") {
            ele.sPatenttype = "发明专利";
          } else if (ele.sPatenttype == "2") {
            ele.sPatenttype = "实用新型";
          } else if (ele.sPatenttype == "3") {
            ele.sPatenttype = "外观设计";
          } else if (ele.sPatenttype == "8") {
            ele.sPatenttype = "PCT发明";
          } else if (ele.sPatenttype == "9") {
            ele.sPatenttype = "PCT实用新型";
          }
        });
        this.total2 = res.data.total;
        this.listBox = true;
      });
    },
    alertDetails(row) {
      this.listName = row.ap;
      this.listapid = row.apid;
      this.alertDetailsmethod();
    },
    manyAlert() {
      this.$confirm("是否确定进行批量提醒操作？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let aps = [];
          let tels = [];
          let nums = [];
          this.multipleSelection.forEach((ele) => {
            aps.push(ele.ap);
            tels.push(ele.tel);
            nums.push(ele.ptNum);
          });
          this.aps = aps.join(";");
          this.tels = tels.join(";");
          this.nums = nums.join(";");
          this.msgalert();
          // this.$router.go(0);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提醒",
          });
        });
    },
    sendConfirm(row) {
      this.aps = row.ap;
      this.tels = row.tel;
      this.nums = row.ptNum;
      this.msgalert();
      // this.$router.go(0);
    },
    // 封装提醒方法
    msgalert() {
      this.$get("/alert/sendMes", {
        token: localStorage.getItem("token"),
        aps: this.aps,
        tels: this.tels,
        nums: this.nums,
      }).then((res) => {
        if (res.status == 200) {
          Message({ message: "提醒成功", type: "success" });
        } else {
          Message({ message: res.msg, type: "warning" });
        }
        this.$router.go(0);
      });
    },
    confirm() {
      this.$get("/alert/updateApInfo", {
        token: localStorage.getItem("token"),
        apid: this.updateBoxmsg.apid,
        name: this.updateBoxmsg.man,
        phone: this.updateBoxmsg.tel,
      }).then((res) => {
        if (res.status == 200) {
          Message({ message: "修改成功", type: "success" });
          this.updataBox = false;
          this.reload();
        }
      });
    },
    updataApplyermsg(row) {
      this.updateBoxmsg.apid = row.apid;
      this.updateBoxmsg.ap = row.ap;
      this.updateBoxmsg.address = row.apad;
      this.updateBoxmsg.man = row.frdb;
      this.updateBoxmsg.tel = row.tel;
      this.updataBox = true;
    },
    closeTk1() {
      this.updataBox = false;
    },
    onSubmit() {
      this.isSubmit = true;
      this.formcopy = JSON.parse(JSON.stringify(this.form));
      if (this.alert == 0) {
        // 查询未提醒
        this.pageNum = 1;
        this.pageSize = 10;
        this.currentPage4 = 1;
        this.mountAlert = false;
        this.alertptSearch();
      } else if (this.alert == 1) {
        // 查询已提醒
        this.pageNum1 = 1;
        this.pageSize1 = 10;
        this.currentPage5 = 1;
        this.mountAlert1 = false;
        if (this.order1 !== "") {
          this.resetSort();
        }
        (this.orderType1 = "desc"), this.alertedptSearch();
      }
    },
    // 高级查询
    alertptSearch() {
      this.$GET("/alert/pt", {
        ap: this.formcopy.ap,
        an: this.formcopy.an,
        pan: this.formcopy.pan,
        name: this.formcopy.name,
        sapd: this.formcopy.sapd,
        eapd: this.formcopy.eapd,
        spd: this.formcopy.spd,
        epd: this.formcopy.epd,
        sad: this.formcopy.sad,
        ead: this.formcopy.ead,
        cnty: this.formcopy.cnty.join(";"),
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    alertedptSearch() {
      this.$get("/alert/ptAlerted", {
        token: localStorage.getItem("token"),
        ap: this.formcopy.ap,
        an: this.formcopy.an,
        pan: this.formcopy.pan,
        name: this.formcopy.name,
        sapd: this.formcopy.sapd,
        eapd: this.formcopy.eapd,
        spd: this.formcopy.spd,
        epd: this.formcopy.epd,
        sad: this.formcopy.sad,
        ead: this.formcopy.ead,
        cnty: this.formcopy.cnty.join(";"),
        pageSize: this.pageSize1,
        pageNum: this.pageNum1,
        orderType: this.orderType1,
      }).then((res) => {
        this.tableDataD = res.data.records;
        this.total1 = res.data.total;
        this.isSubmit=false
      });
    },
    resetData() {
      this.form.ap = "";
      this.form.an = "";
      this.form.pan = "";
      this.form.name = "";
      this.form.sapd = "";
      this.form.eapd = "";
      this.form.spd = "";
      this.form.epd = "";
      this.form.sad = "";
      this.form.ead = "";
      this.form.cnty = [];
    },
    handlegjcxShow() {
      this.gjcxShow = this.gjcxShow ? false : true;
    },
    handleCheckedCompanyChange5(value) {
      this.checkAll5 = value.length == this.regions.length;
    },
    handleCheckAllChange5(value) {
      value ? (this.form.cnty = this.regions) : (this.form.cnty = []);
    },
    alertClick(val) {
      this.alert = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
    },
    handleSelectionChange2(val) {},
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.mountAlert) {
        this.notAlert();
      } else {
        this.alertptSearch();
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.mountAlert) {
        this.notAlert();
      } else {
        this.alertptSearch();
      }
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      if (this.mountAlert1) {
        this.hasAlerted();
      } else {
        this.alertedptSearch();
      }
    },
    handleCurrentChange1(val) {
      this.pageNum1 = val;
      if (this.mountAlert1) {
        this.hasAlerted();
      } else {
        this.alertedptSearch();
      }
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.alertDetailsmethod();
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.alertDetailsmethod();
    },
    // 获取未提醒列表
    notAlert() {
      this.$GET("/alert/pt", {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      }).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 获取已提醒列表
    hasAlerted() {
      this.$get("/alert/ptAlerted", {
        token: localStorage.getItem("token"),
        pageSize: this.pageSize1,
        pageNum: this.pageNum1,
        orderType: this.orderType1,
      }).then((res) => {
        this.tableDataD = res.data.records;
        this.total1 = res.data.total;
      });
    },
    // 导出
    daochu() {
      if (JSON.stringify(this.formcopy) == "{}") {
        // 没有查询时
        var apids = [];
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((ele) => {
            apids.push(ele.apid);
          });
          apids = apids.join(";");
        } else if (this.multipleSelection.length == 0) {
          apids = "";
        }
        let aLink = document.createElement("a");
        aLink.href =
          this.$url +
          "alert/ptExport?" +
          "token=" +
          localStorage.getItem("token") +
          "&uid=" +
          localStorage.getItem("uid") +
          "&apids=" +
          apids;
        aLink.click();
      } else {
        //查询时
        let apidss = [];
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach((ele) => {
            apidss.push(ele.apid);
          });
          apidss = apidss.join(";");
          let aLink5 = document.createElement("a");
          aLink5.href =
            this.$url +
            "alert/ptExport?" +
            "token=" +
            localStorage.getItem("token") +
            "&uid=" +
            localStorage.getItem("uid") +
            "&apids=" +
            apidss;
          aLink5.click();
        } else if (this.multipleSelection.length == 0) {
          var form = this.formcopy;
          let aLink2 = document.createElement("a");
          aLink2.href =
            this.$url +
            "alert/ptExport?" +
            "token=" +
            localStorage.getItem("token") +
            "&uid=" +
            localStorage.getItem("uid") +
            "&ap=" +
            form.ap +
            "&an=" +
            form.an +
            "&pan=" +
            form.pan +
            "&name=" +
            form.name +
            "&sapd=" +
            form.sapd +
            "&eapd=" +
            form.eapd +
            "&spd=" +
            form.spd +
            "&epd=" +
            form.epd +
            "&sad=" +
            form.sad +
            "&ead=" +
            form.ead +
            "&cnty=" +
            form.cnty.join(";");
          aLink2.click();
        }
      }
    },
    daochu2() {
      if (JSON.stringify(this.formcopy) == "{}") {
        //没有查询时，无条件导出
        if (this.multipleSelection1.length > 0) {
          //有勾选时
          let aps = [];
          this.multipleSelection1.forEach((ele) => {
            aps.push(ele.ap);
          });
          let aLink3 = document.createElement("a");
          aLink3.href =
            this.$url +
            "alert/ptAlertedExport?token=" +
            localStorage.getItem("token") +
            "&aps=" +
            aps.join(";");
          aLink3.click();
        } else {
          //没有勾选时
          let aLink4 = document.createElement("a");
          aLink4.href =
            this.$url +
            "alert/ptAlertedExport?token=" +
            localStorage.getItem("token") +
            "&orderType=" +
            this.orderType1;
          aLink4.click();
        }
      } else {
        //有查询时
        if (this.multipleSelection1.length > 0) {
          //部分导出
          let aps = [];
          this.multipleSelection1.forEach((ele) => {
            aps.push(ele.ap);
          });
          let aLink6 = document.createElement("a");
          aLink6.href =
            this.$url +
            "alert/ptAlertedExport?token=" +
            localStorage.getItem("token") +
            "&aps=" +
            aps.join(";");
          aLink6.click();
        } else {
          //全部导出
          var alertedform = this.formcopy;
          let aLink5 = document.createElement("a");
          aLink5.href =
            this.$url +
            "alert/ptAlertedExport?token=" +
            localStorage.getItem("token") +
            "&ap=" +
            alertedform.ap +
            "&an=" +
            alertedform.an +
            "&pan=" +
            alertedform.pan +
            "&name=" +
            alertedform.name +
            "&sapd=" +
            alertedform.sapd +
            "&eapd=" +
            alertedform.eapd +
            "&spd=" +
            alertedform.spd +
            "&epd=" +
            alertedform.epd +
            "&sad=" +
            alertedform.sad +
            "&ead=" +
            alertedform.ead +
            "&cnty=" +
            alertedform.cnty.join(";") +
            "&orderType=" +
            this.orderType1;
          aLink5.click();
        }
      }
    },
    //重置排序
    resetSort() {
      this.$refs.multipleTable1.sort(this.order1, null);
    },
  },
  mounted() {
    let regions = JSON.parse(localStorage.getItem("DataPermission"));
    let regionName = [];
    regions.forEach((element) => {
      regionName.push(element.name);
    });
    this.regions = regionName;
    this.notAlert();
    this.hasAlerted();
  },
};
</script>
<style>
.alertPatent .el-form-item--mini.el-form-item {
  margin-bottom: 12px;
}
.listBox {
  width: 70vw;
  margin-left: -35vw;
  min-width: 957px;
}
.alertPatent .el-form-item {
  margin-bottom: 2px;
}
.alertType {
  display: flex;
  cursor: pointer;
  margin-left: 21px;
  margin-top: 14px;
}
.alertType > div {
  width: 142px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: #303133;
  font-size: 14px;
}
.alertType > div:first-child {
  border-top-left-radius: 4px;
  border-left: 1px solid #0064d0;
  border-top: 1px solid #0064d0;
}
.alertType > div:last-child {
  border-right: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}
.chooseAlert {
  background: #0064d0;
  color: #ffffff !important;
  font-size: 18px !important;
}

/* .changeAlert {
  
} */
.changeAlert button {
  outline: 0;
  width: 42px;
  height: 21px;
  font-size: 12px;
  text-align: center;
  line-height: 22px;
  border: 0;
  cursor: pointer;
}
.changeAlert button:first-child {
  background: #ddebff;
  color: #055fe6;
}
/* .changeAlert button:last-child {
  background: #ffe9cf;
  color: #ec8204; 
   margin-left: 9px; 
} */
.Reupdate {
  color: #000000;
  font-size: 14px;
}
.Reupdate span {
  color: #606060;
}
.Reupdate > div {
  margin-bottom: 13px;
}
.Reupdate input {
  width: 200px;
  height: 20px;
  padding: 4px 7px;
  border: 1px solid #eeeeee;
  outline: 0;
  border-radius: 4px;
}
.reBtnb {
  display: flex;
  justify-content: center;
  margin-top: 19px;
  margin-bottom: 4px;
}
.reBtnb > .el-button {
  width: 121px;
  height: 36px;
  padding: 0;
  text-align: center;
  line-height: 36px;
}
.reBtnb > .el-button:first-child {
  border: 1px solid #369afe;
  color: #369afe;
  font-size: 16px;
}
.reBtnb > .el-button:last-child {
  background: #1471d5;
  color: #fff;
  font-size: 16px;
}
.alertPatent .el-popconfirm__action {
  margin-top: 12px;
}
.alertPatent .gjcxContent .el-form-item__content{
  text-align: center;
}
</style>